import { render, staticRenderFns } from "./BusinessGlossaryPage.vue?vue&type=template&id=4b35e9e2&lang=pug"
import script from "./BusinessGlossaryPage.vue?vue&type=script&lang=js"
export * from "./BusinessGlossaryPage.vue?vue&type=script&lang=js"
import style0 from "./BusinessGlossaryPage.vue?vue&type=style&index=0&id=4b35e9e2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b35e9e2')) {
      api.createRecord('4b35e9e2', component.options)
    } else {
      api.reload('4b35e9e2', component.options)
    }
    module.hot.accept("./BusinessGlossaryPage.vue?vue&type=template&id=4b35e9e2&lang=pug", function () {
      api.rerender('4b35e9e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/business_terms/BusinessGlossaryPage.vue"
export default component.exports